import { getRate } from '@/api/exchange-rate'
const state = {
  rate: []
}
const mutations = {
  SET_RATE: (state, rate) => {
    state.rate = rate
  },
}
const actions = {
  getRate({commit}) {
    return new Promise((resolve, reject) => {
      getRate().then(response => {
        commit('SET_RATE', response.data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
